<template>
  <div class="mx-percent mt-lg-35 mt-16">
    <v-row no-gutters>
      <v-col
        class="font-size-lg-32 font-size-25 poppins font-weight-semi-bold text-center line-break dialogDark--text"
        v-html="$t('pagina.caracteristicas-pesaje.titulo')"
      ></v-col>
    </v-row>
    <v-row no-gutters class="mt-lg-16 mt-8">
      <v-col
        cols="12"
        lg="4"
        v-for="caracteristica in caracteristicas"
        :key="`caracteristica-${caracteristica.id}`"
        :class="{
          'pr-6': caracteristica.id % 3 === 1 && !isMobile,
          'px-6': caracteristica.id % 3 === 2 && !isMobile,
          'pl-6': caracteristica.id % 3 === 0 && !isMobile,
          'pt-lg-9 pt-8':
            caracteristica.id / 3 > 1 || (caracteristica.id > 1 && isMobile),
        }"
      >
        <v-row no-gutters>
          <v-col cols="auto">
            <v-img
              :src="caracteristica.icono"
              height="68px"
              width="68px"
              contain
            ></v-img>
          </v-col>
          <v-col class="pl-7">
            <v-row no-gutters>
              <v-col
                class="font-size-18 poppins font-weight-medium dialogDark--text"
              >
                {{ caracteristica.titulo }}
              </v-col>
            </v-row>
            <v-row no-gutters class="mt-lg-2 mt-4">
              <v-col
                class="font-size-16 poppins font-weight-light dialogDark--text"
              >
                {{ caracteristica.parrafo }}
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script lang="ts">
//decoradores
import { Component, Vue } from "vue-property-decorator";

@Component
export default class CaracteristicasPesajePagina extends Vue {
  get caracteristicas(): Array<{
    id: number;
    icono: string;
    titulo: string;
    parrafo: string;
  }> {
    return [
      {
        id: 1,
        icono: require("../../assets/png/one-page/weight.png"),
        titulo: this.$t(
          "pagina.caracteristicas-pesaje.caracteristicas.0.titulo"
        ) as string,
        parrafo: this.$t(
          "pagina.caracteristicas-pesaje.caracteristicas.0.parrafo"
        ) as string,
      },
      {
        id: 2,
        icono: require("../../assets/png/one-page/web.png"),
        titulo: this.$t(
          "pagina.caracteristicas-pesaje.caracteristicas.1.titulo"
        ) as string,
        parrafo: this.$t(
          "pagina.caracteristicas-pesaje.caracteristicas.1.parrafo"
        ) as string,
      },
      {
        id: 3,
        icono: require("../../assets/png/one-page/image.png"),
        titulo: this.$t(
          "pagina.caracteristicas-pesaje.caracteristicas.2.titulo"
        ) as string,
        parrafo: this.$t(
          "pagina.caracteristicas-pesaje.caracteristicas.2.parrafo"
        ) as string,
      },
      {
        id: 4,
        icono: require("../../assets/png/one-page/truck.png"),
        titulo: this.$t(
          "pagina.caracteristicas-pesaje.caracteristicas.3.titulo"
        ) as string,
        parrafo: this.$t(
          "pagina.caracteristicas-pesaje.caracteristicas.3.parrafo"
        ) as string,
      },
      {
        id: 5,
        icono: require("../../assets/png/one-page/shield.png"),
        titulo: this.$t(
          "pagina.caracteristicas-pesaje.caracteristicas.4.titulo"
        ) as string,
        parrafo: this.$t(
          "pagina.caracteristicas-pesaje.caracteristicas.4.parrafo"
        ) as string,
      },
      {
        id: 6,
        icono: require("../../assets/png/one-page/document.png"),
        titulo: this.$t(
          "pagina.caracteristicas-pesaje.caracteristicas.5.titulo"
        ) as string,
        parrafo: this.$t(
          "pagina.caracteristicas-pesaje.caracteristicas.5.parrafo"
        ) as string,
      },
      {
        id: 7,
        icono: require("../../assets/png/one-page/dashboard.png"),
        titulo: this.$t(
          "pagina.caracteristicas-pesaje.caracteristicas.6.titulo"
        ) as string,
        parrafo: this.$t(
          "pagina.caracteristicas-pesaje.caracteristicas.6.parrafo"
        ) as string,
      },
      {
        id: 8,
        icono: require("../../assets/png/one-page/user.png"),
        titulo: this.$t(
          "pagina.caracteristicas-pesaje.caracteristicas.7.titulo"
        ) as string,
        parrafo: this.$t(
          "pagina.caracteristicas-pesaje.caracteristicas.7.parrafo"
        ) as string,
      },
    ];
  }

  get isMobile(): boolean {
    return this.$vuetify.breakpoint.mobile;
  }
}
</script>

<style scoped>
@media screen and (min-width: 1264px) {
  .mt-lg-35 {
    margin-top: 140px !important;
  }
}
</style>
